export default "__VITE_ASSET__m6iqBsL0__"